module.exports = __webpack_public_path__ + "static/media/317-3172926_angry-birds-clipart-angry-birds-friends-angry-birds-angry-birds-circular.f6f4c941.png";